import React, { createContext, useContext, useEffect, useState } from 'react';

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    return sessionStorage.getItem('site_lang') ?? 'bn';
  });

  useEffect(() => {
    sessionStorage.setItem('site_lang', lang);
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  return useContext(LangContext);
};
